<div class="toaster position-fixed top-0 start-50 translate-middle-x">
  <div *ngFor="let toast of currentToasts; index as i">
    <app-toast
      [type]="toast.type"
      [message]="toast.message"
      [delay]="toast.delay!"
      (disposeEvent)="dispose(i)"
    ></app-toast>
  </div>
</div>
